<template>
    <button class="base-button"
        :class="'base-button_' + buttonStyle + ' base-button_' + buttonSize"
        :type="type"
        @click="$emit('click')"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'BaseButton',
    props: {
        type: {
            type: String,
            default: 'button'
        },
        buttonStyle: {
            type: String,
            default: 'primary',
            validator(value) {
                return ['primary', 'secondary', 'black', 'dark-gray'].includes(value)
            }
        },
        buttonSize: {
            type: String,
            default: 'medium',
            validator(value) {
                return ['medium', 'large'].includes(value)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.base-button {
    border: none;
    border-radius: 4px;
    padding: 12px 24px;
    font-size: 14px;
    cursor: pointer;

    &_large {
        padding: 16px 32px;
    }

    &_primary {
        background-color: $rfx-bright-turquoise;
        color: white;
    }

    &_secondary {
        background-color: transparent;
        color: $rfx-dark-march;
    }

    &_black {
        background-color: $rfx-dark-march;
        color: white;
    }

    &_dark-gray {
        background-color: $rfx-medium-march;
        color: white;
    }
}
</style>